export enum ActivatePreviewTab {
  QUERY,
  MAPPING
}
